import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels'; // opcional si usas etiquetas

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  // ChartDataLabels
);

const GraficaFrecuenciaPorValor = ({ pesos }) => {
  // 🔧 Parámetros de rango (puedes parametrizar desde BD/config)
  const rangoMin = 45.4;
  const rangoMax = 45.7;

  // 📊 Agrupamos por décima
  const frecuencia = {};
  pesos.forEach(val => {
    const clave = val.toFixed(1);
    frecuencia[clave] = (frecuencia[clave] || 0) + 1;
  });

  const labels = Object.keys(frecuencia).sort((a, b) => parseFloat(a) - parseFloat(b));
  const valores = labels.map(k => frecuencia[k]);

  // 🎨 Colores condicionales por barra
  const backgroundColor = labels.map(label => {
    const valor = parseFloat(label);
    return valor >= rangoMin && valor <= rangoMax ? '#ff6666' : '#66b3ff'; // Rojo si está en rango
  });

  const borderColor = labels.map(label => {
    const valor = parseFloat(label);
    return valor >= rangoMin && valor <= rangoMax ? '#cc0000' : '#3399ff'; // Borde rojo si está en rango
  });

  const data = {
    labels,
    datasets: [
      {
        label: 'Frecuencia por valor',
        data: valores,
        backgroundColor,
        borderColor,
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: context => `Repeticiones: ${context.raw}`
        }
      },
      // datalabels: {
      //   anchor: 'end',
      //   align: 'top',
      //   color: '#000',
      //   font: {
      //     weight: 'bold',
      //     size: 12
      //   },
      //   formatter: value => value
      // }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Cantidad' }
      },
      x: {
        title: { display: true, text: 'Valor de peso (kg)' }
      }
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Frecuencia por Valor de Peso <br />
        <span style={{ fontSize: '0.9rem', color: '#555' }}>
          Rango marcado: {rangoMin} kg – {rangoMax} kg
        </span>
      </h4>
      <Bar data={data} options={options} />
    </div>
  );
};

export default GraficaFrecuenciaPorValor;